<script lang="ts">
	import Search from '@lucide/svelte/icons/search'
	import type { HTMLInputAttributes } from 'svelte/elements'
	import { cn } from 'tailwind-variants'

	import * as InputGroup from '#lib/components/ui/input-group/index.js'
	import { n } from '#lib/utils/navigation.svelte.js'
	import { SEARCH_MAX_LENGTH } from '#lib/utils/schema.js'

	let {
		class: className,
		value = $bindable(),
		placeholder = '',
		...restProps
	}: Omit<HTMLInputAttributes, 'type' | 'files'> & {} = $props()
</script>

<InputGroup.Root class={cn('relative flex-1', className)}>
	<InputGroup.Addon>
		<Search />
	</InputGroup.Addon>

	<InputGroup.Input
		name="search"
		autocomplete="off"
		maxlength={SEARCH_MAX_LENGTH}
		{placeholder}
		readonly={n.l}
		size={1}
		spellcheck={false}
		type="search"
		bind:value
		{...restProps}
	/>
</InputGroup.Root>
